import { render, staticRenderFns } from "./ProcessDangerTask.vue?vue&type=template&id=cb2bad30&scoped=true"
import script from "./js/ProcessDangerTask.js?vue&type=script&lang=js&external"
export * from "./js/ProcessDangerTask.js?vue&type=script&lang=js&external"
import style0 from "./ProcessDangerTask.vue?vue&type=style&index=0&id=cb2bad30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2bad30",
  null
  
)

export default component.exports